module.exports = __webpack_public_path__ + "img/certificate5.8d43ac92.png";